import { clearOnboardingOtpEligibleAt } from 'utils/onboardingOtpReadiness';

const ONBOARDING_PREFILL_KEY = 'spence_onboarding_prefill';
const OTP_VERIFIED_LOCK_KEY = 'spence_onboarding_otp_verified';

export type OnboardingPrefill = {
  email?: string;
  preferredName?: string;
  phone?: string;
  verificationType?: 'phone' | 'email';
  verificationMethod?: 'phone' | 'email';
};

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

function getSessionStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage;
}

export function readOnboardingPrefill(): OnboardingPrefill {
  const storage = getSessionStorage();
  if (!storage) {
    return {};
  }

  const raw = storage.getItem(ONBOARDING_PREFILL_KEY);
  if (!raw) {
    return {};
  }

  try {
    const parsed = JSON.parse(raw) as OnboardingPrefill;
    return {
      ...(isNonEmptyString(parsed.email) ? { email: parsed.email.trim() } : {}),
      ...(isNonEmptyString(parsed.preferredName)
        ? { preferredName: parsed.preferredName.trim() }
        : {}),
      ...(isNonEmptyString(parsed.phone) ? { phone: parsed.phone.trim() } : {}),
      ...(parsed.verificationType === 'phone' || parsed.verificationType === 'email'
        ? { verificationType: parsed.verificationType }
        : {}),
      ...(parsed.verificationMethod === 'phone' || parsed.verificationMethod === 'email'
        ? { verificationMethod: parsed.verificationMethod }
        : {}),
    };
  } catch {
    return {};
  }
}

export function writeOnboardingPrefill(next: OnboardingPrefill): void {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  const current = readOnboardingPrefill();
  const merged: OnboardingPrefill = {
    ...current,
    ...next,
  };

  storage.setItem(ONBOARDING_PREFILL_KEY, JSON.stringify(merged));
}

export function clearOnboardingJourneyState(): void {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(ONBOARDING_PREFILL_KEY);
  storage.removeItem(OTP_VERIFIED_LOCK_KEY);
  clearOnboardingOtpEligibleAt();
}
